import { Grid2 as Grid, Typography } from '@mui/material'
import CompensationChartCard from 'components/cards/CompensationChartCard'
import { useCreatePlanContext } from 'contexts/CreatePlanContextProvider'
import { useState } from 'react'

import PlanAllocationTables from './PlanAllocationTables'
import PlanTargets from './PlanTargets'
import WizardCompensationHeader from './WizardCompensationHeader'

function ReviewPlan() {
  const { plan } = useCreatePlanContext()
  const [chartViewMode, setChartViewMode] = useState<'summary' | 'breakdown'>('summary')

  const baseSalary = plan.baseSalary || 0
  const variablePercent = plan.variablePercent || 0
  const periodProration = plan.periodProration || 1.0

  const baseCompensation = baseSalary * periodProration
  const variableCompensation = baseSalary * variablePercent * periodProration

  // Calculate allocation totals for chart breakdown view
  const allAllocations = plan.variableAllocations.flatMap((group) =>
    group.rows
      .filter((row) => !row.disabled && (row.allocationPercentage || 0) > 0)
      .map((row) => ({
        label: row.label,
        value: baseSalary * variablePercent * (row.allocationPercentage || 0) * periodProration,
      }))
  )

  const chartSeries = allAllocations.map((a) => a.value)
  const chartLabels = allAllocations.map((a) => a.label)

  return (
    <Grid container spacing={3}>
      {/* Left section: content */}
      <Grid size={{ xs: 12, md: 9 }}>
        <Grid container spacing={3} alignItems="center">
          <Grid size={{ xs: 12 }}>
            <WizardCompensationHeader />
          </Grid>

          {/* Chart - Mobile only, shown after header */}
          <Grid size={{ xs: 12 }} sx={{ display: { xs: 'block', md: 'none' } }}>
            <CompensationChartCard
              title="Compensation Breakdown"
              showToggle={true}
              viewMode={chartViewMode}
              onViewModeChange={setChartViewMode}
              customSeries={chartViewMode === 'summary' ? [baseCompensation, variableCompensation] : chartSeries}
              customLabels={chartViewMode === 'summary' ? ['Base', 'Variable'] : chartLabels}
            />
          </Grid>

          <Grid size={{ xs: 12 }}>
            <Typography variant="h5" fontWeight="bold" sx={{ mb: -1 }}>
              Targets
            </Typography>
          </Grid>
          <Grid size={{ xs: 12 }}>
            <PlanTargets reviewOnly />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Typography variant="h5" fontWeight="bold" sx={{ mb: -1 }}>
              Allocations
            </Typography>
          </Grid>
          <Grid size={{ xs: 12 }}>
            <PlanAllocationTables reviewOnly />
          </Grid>
        </Grid>
      </Grid>

      {/* Right section: Chart - desktop only */}
      <Grid size={{ xs: 12, md: 3 }} sx={{ display: { xs: 'none', md: 'block' } }}>
        <CompensationChartCard
          title="Compensation Breakdown"
          showToggle={true}
          viewMode={chartViewMode}
          onViewModeChange={setChartViewMode}
          customSeries={chartViewMode === 'summary' ? [baseCompensation, variableCompensation] : chartSeries}
          customLabels={chartViewMode === 'summary' ? ['Base', 'Variable'] : chartLabels}
        />
      </Grid>
    </Grid>
  )
}

export default ReviewPlan
